import type { ReactNode } from 'react';
import { QueryProvider } from './QueryProvider';
import { ThemeProvider } from './ThemeProvider';
import { I18nProvider } from './I18nProvider';
import { AuthProvider } from '@/features/identity-management/auth/providers/AuthProvider';
import { ToastProvider } from '@/shared/ui/primitives';

interface AppProvidersProps {
  children: ReactNode;
}

/**
 * Composes the app's cross-cutting providers in the order they depend on each
 * other:
 *
 *   QueryProvider  (server state — outermost, lifetime-scoped)
 *     ThemeProvider  (writes [data-theme] onto <html>)
 *       I18nProvider (writes lang + dir onto <html>)
 *         AuthProvider (memory access token + refresh restore)
 *           ToastProvider (workspace notifications)
 *             <children />
 */
export function AppProviders({ children }: AppProvidersProps): ReactNode {
  return (
    <QueryProvider>
      <ThemeProvider>
        <I18nProvider>
          <AuthProvider>
            <ToastProvider>{children}</ToastProvider>
          </AuthProvider>
        </I18nProvider>
      </ThemeProvider>
    </QueryProvider>
  );
}
